import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'payroll',
    permissionsPrefix: 'hr',
    displayName: 'Payroll',

    navSections: [
        { key: 'payroll', label: 'Payroll', route: '/payroll/payslips' },
        { key: 'reports', label: 'Reporting', route: '/payroll/salarySheetReport' },
        { key: 'configuration', label: 'Configuration', route: '/payroll/salaryComponents' },
    ],

    resources: [
        { key: 'payslips', label: 'Payslips', navSection: 'payroll' },
        { key: 'payslipPosting', label: 'Payslips — post/unpost', navSection: 'payroll' },
        { key: 'payrollPeriods', label: 'Payroll Periods', navSection: 'payroll' },
        { key: 'employeeContracts', label: 'Employee Contracts', navSection: 'payroll' },
        { key: 'employeeLeaves', label: 'Employee Leaves', navSection: 'payroll' },
        { key: 'loans', label: 'Loans & Advances', navSection: 'payroll' },
        { key: 'salarySheetReport', label: 'Salary Sheet Report', navSection: 'reports' },
        { key: 'salaryComponents', label: 'Salary Components', navSection: 'configuration' },
        { key: 'salaryStructures', label: 'Salary Structures', navSection: 'configuration' },
        { key: 'taxSlabs', label: 'Income Tax Slabs', navSection: 'configuration' },
        { key: 'leaveTypes', label: 'Leave Types', navSection: 'configuration' },
    ],
} satisfies WorkspaceAppManifest;
